<div class="content-header">
  <div
    [ngClass]="{
      'content--left': align === 'left',
      'content--center': align === 'center',
      'content--right': align === 'right',
      'content--large': maxWidth === 'large'
    }"
    class="content">
    @if (backLink) {
      <a class="body-m back-link" [routerLink]="backLink">
        <mat-icon class="back-link__icon" svgIcon="arrow-back-orange"></mat-icon>
        {{ backLinkText }}
      </a>
    }

    <h2 class="content-header__title heading-s">
      {{ title }}
      @if (tooltip) {
        <mat-icon
          [matTooltip]="tooltip | translate"
          [matTooltipTouchGestures]="'on'"
          [matTooltipClass]="'custom-tooltip'"
          class="tooltip"
          [matTooltipPosition]="'below'"
          #mattooltip="matTooltip"
          (click)="mattooltip.toggle()">
          info
        </mat-icon>
      }
    </h2>
    <h2 class="content-header__title heading-m">{{ titleContact }}</h2>
    <p class="content-header__subtitle body-m">
      {{ subtitle }}
      <span class="body-m-bold">{{ subtitleBold }}</span>
      <span class="heading-xs basket-title">{{ subtitleBasket }}</span>
      <span class="body-l basket-title">{{ subtitleContact }}</span>
    </p>
  </div>
</div>
